import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "./fontawesome-regular";
import "./fontawesome-solid";

export default FontAwesomeIcon;
